import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Footer from "../Footer";
import Header from "../Header";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import "../../assets/css/register.css";
import auth from "../../utils/auth";
import { IonPage } from "@ionic/react";

const Register = (props) => {
	const [isOpaque, setIsOpaque] = useState(true);

	const [fullName, setFullName] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [error, setError] = useState("");

	const navigate = useNavigate();

	const registerUser = async () => {
		if (!fullName || !email || !password || !confirmPassword) {
			setError("Please fill in all fields");
			return;
		}
		if (password !== confirmPassword) {
			setError("Passwords don't match");
			return;
		}
		try {
			const response = await axios.post("/auth/register", {
				fullName,
				email,
				password,
			});

			await auth.setToken(response.data.token, true);
			await auth.setUserInfo(response.data.user, true);

			navigate("/courses", { replace: true });
		} catch (e) {
			console.log(e.response?.data.message || e);
			setError(e.response?.data.message || "Something went wrong");
		}
	};

	useEffect(() => {
		window.addEventListener("scroll", (e) => {
			if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
				setIsOpaque(false);
			} else {
				setIsOpaque(true);
			}
		});

		return () => {
			window.removeEventListener("scroll", (e) => {
				if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
					setIsOpaque(false);
				} else {
					setIsOpaque(true);
				}
			});
		};
	}, []);

	return (
		<IonPage>
			<div id="header_place">
				<Header isOpaque={isOpaque} isBlue={true} />
			</div>
			<section id="hero_area5">
				<div class="center_wrapper">
					<Carousel
						showThumbs={false}
						showStatus={false}
						showArrows={false}
						swipeable={true}
						className="c1"
					>
						<div className="slide_wrapper3">
							<p>Your learning journey starts here</p>
							<img
								src={`${process.env.PUBLIC_URL}/assets/illustration.png`}
								className="illustration"
							/>
							<h3>Feedback based learning</h3>
						</div>
						<div className="slide_wrapper3">
							<p>Your learning journey starts here</p>
							<img
								src={`${process.env.PUBLIC_URL}/assets/illustration.png`}
								className="illustration"
							/>
							<h3>Feedback based learning</h3>
						</div>
						<div className="slide_wrapper3">
							<p>Your learning journey starts here</p>
							<img
								src={`${process.env.PUBLIC_URL}/assets/illustration.png`}
								className="illustration"
							/>
							<h3>Feedback based learning</h3>
						</div>
					</Carousel>
					<div class="register_content">
						<h1>Create Account</h1>
						<p className="subtext2">
							Already have an account? Sign In{" "}
							<a href="/auth/login">here</a>.
						</p>

						{error && (
							<div className="auth_error" role="alert">
								<span className="auth_error_icon">!</span>
								{error}
							</div>
						)}
						<input
							type="text"
							className={"ip" + (error ? " has-error" : "")}
							placeholder="Full Name"
							value={fullName}
							onChange={(e) => {
								setFullName(e.target.value);
								setError("");
							}}
						/>
						<input
							type="email"
							className={"ip" + (error ? " has-error" : "")}
							placeholder="Email Id"
							value={email}
							onChange={(e) => {
								setEmail(e.target.value);
								setError("");
							}}
						/>
						<input
							type="password"
							className={"ip" + (error ? " has-error" : "")}
							placeholder="Password"
							value={password}
							onChange={(e) => {
								setPassword(e.target.value);
								setError("");
							}}
						/>
						<input
							type="password"
							className={"ip" + (error ? " has-error" : "")}
							placeholder="Confirm Password"
							value={confirmPassword}
							onKeyDown={(e) => {
								if (e.key === "Enter") registerUser();
							}}
							onChange={(e) => {
								setConfirmPassword(e.target.value);
								setError("");
							}}
						/>
						<button
							className="submit learn"
							type="button"
							onClick={registerUser}
						>
							Start Learning
						</button>
					</div>
				</div>
			</section>
		</IonPage>
	);
};

export default Register;
